import React, { useEffect, useState } from "react";
import "../../../assets/css/Blog.css";
import Card from "react-bootstrap/Card";
// import Blog_one from "../../../assets/image/Blog/blog-sub-1.jpg";
import sensor from "../../../assets/image/Home/sensor.jpg";
import { Form, InputGroup, Row, Col } from "react-bootstrap";
import { FaSearch } from "react-icons/fa";
import BlogPost from "../../../assets/image/Blog/blog-post.jpg";
import { TiArrowRight } from "react-icons/ti";
import Footer from "../../Footer/Footer";
import { Dropdown } from "react-bootstrap";
import { Helmet, HelmetProvider } from "react-helmet-async";
import data from "../../../Meta/Meta_ApiUrl";

import { useNavigate } from "react-router-dom";

const Blog = () => {
  const navigate = useNavigate();
  const [meta, setMeta] = useState({});
  useEffect(() => {
    // Directly access about_page from data
    const BlogMeta = data[0]?.blog_page;

    // Set meta state if about Meta exists
    if (BlogMeta) {
      setMeta(BlogMeta);
    }
  }, []);

  // Page Navigation
  const handleClickBlogSub = () => {
    navigate("/blogsub_1");
  };

  // Card
  const blogData = [
    {
      image: sensor,
      title: "How IoT Sensors Are Powering Smart Systems",
      date: "Mar 20, 2026",
      author: "Admin",
      category: "IoT",
    },
  ];

  // Recent post
  const recentPosts = [
    {
      id: 1,
      date: "Mar 20, 2026",
      title: <>AI in Modern Game Development</>,
      image: sensor,
    },
    {
      id: 2,
      date: "Mar 15, 2026",
      title: <>Robotics in Real-World Applications</>,
      image: BlogPost,
    },
    {
      id: 3,
      date: "Mar 12, 2026",
      title: <>Drone Technology & Automation</>,
      image: BlogPost,
    },
    {
      id: 4,
      date: "Mar 08, 2026",
      title: <>Future of IoT in Smart Cities</>,
      image: BlogPost,
    },
  ];

  // Categories
  const categories = [
    { name: "Artificial Intelligence", count: 5 },
    { name: "IoT & Smart Systems", count: 4 },
    { name: "Robotics", count: 3 },
    { name: "Drone Technology", count: 2 },
    { name: "Web & App Development", count: 7 },
  ];

  // Scroll Up
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <HelmetProvider>
      <Helmet>
        <title>{meta?.title || "Blog - Shiv Next Gen"}</title>
        <meta
          name="description"
          content={
            meta?.meta?.meta1?.content ||
            "Explore insights on AI, IoT, robotics, and modern IT solutions from Shiv Next Gen."}
        />
      </Helmet>
      {/* Banner */}
      <div
        className="position-relative min-vh-50 blog-bg d-flex align-items-center justify-content-center bg-dark text-white"
        style={{ overflowX: "hidden", width: "100%" }}
      >
        <div className="container position-relative px-3 px-md-4">
          <div className="row align-items-center">
            <div className="col-12 blog-content">
              <nav
                aria-label="breadcrumb"
                className="mb-3 mb-md-4"
              // data-aos="fade-right"
              // data-aos-delay="100"
              >
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <a href="/" className="text-white fw-bold text-decoration ">
                      Home
                    </a>
                  </li>
                  <li className="breadcrumb-item fw-bold" aria-current="page">
                    Blog
                  </li>
                </ol>
              </nav>
              <h3 className="display-5 fw-bold">
                Latest <span className="font-red">Insights</span>
              </h3>
            </div>
          </div>
        </div>
      </div>

      {/* Top Sections */}
      <div className="container my-5">
        <div className="row g-4">
          {/* Search */}
          <div className="col-lg-4 col-md-6 col-sm-12 d-flex">
            <div className="shadow p-3 rounded-3 bg-white w-100 d-flex flex-column">
              {/* Header */}
              <div className="d-flex align-items-center mb-3">
                <div
                  className="me-3 rounded"
                  style={{
                    width: "4px",
                    height: "25px",
                    background: "#41C1EE",
                  }}
                ></div>
                <h5
                  className="fw-bold font-black mb-0"
                  style={{ fontSize: "20px" }}
                >
                  SEARCH
                </h5>
              </div>
              {/* Content */}
              <InputGroup className="mt-auto">
                <Form.Control
                  type="text"
                  placeholder="Search"
                  className="py-2 px-3"
                  style={{ fontSize: "18px", borderColor: "#e0e0e0" }}
                />
                <InputGroup.Text
                  className="border-start-0"
                  style={{ cursor: "pointer", backgroundColor: "#41C1EE" }}
                >
                  <FaSearch className="text-white" />
                </InputGroup.Text>
              </InputGroup>
            </div>
          </div>

          {/* Categories */}
          <div className="col-lg-4 col-md-6 col-sm-12 d-flex">
            <div className="shadow p-3 rounded-3 bg-white w-100 d-flex flex-column">
              {/* Header */}
              <div className="d-flex align-items-center mb-3">
                <div
                  className="me-3 rounded"
                  style={{
                    width: "4px",
                    height: "25px",
                    background: "#41C1EE",
                  }}
                ></div>
                <h5 className="fw-bold font-black mb-0">CATEGORIES</h5>
              </div>
              {/* Content */}
              <Dropdown className="mt-auto">
                <Dropdown.Toggle
                  variant="light"
                  className="w-100 d-flex justify-content-between align-items-center text-start fw-medium border"
                >
                  <span>Select a Category</span>
                </Dropdown.Toggle>

                <Dropdown.Menu className="w-100">
                  {categories.map((category, index) => (
                    <Dropdown.Item
                      key={index}
                      className="blog-category-item d-flex px-2 align-items-center"
                    >
                      <span className="arrow-icon me-2">
                        <TiArrowRight />
                      </span>
                      <span className="flex-grow-1 fw-semibold text-decoration-none">
                        {category.name}
                      </span>
                      <span className="count small fw-semibold">
                        ({category.count})
                      </span>
                    </Dropdown.Item>
                  ))}
                </Dropdown.Menu>
              </Dropdown>
            </div>
          </div>

          {/* Tags */}
          <div className="col-lg-4 col-md-12 col-sm-12 d-flex">
            <div className="shadow p-3 rounded-3 bg-white w-100 d-flex flex-column">
              {/* Header */}
              <div className="d-flex align-items-center mb-3">
                <div
                  className="me-3 rounded"
                  style={{
                    width: "4px",
                    height: "25px",
                    background: "#41C1EE",
                  }}
                ></div>
                <h5 className="fw-bold font-black text-dark mb-0">TAGS</h5>
              </div>

              {/* Content */}
              <div className="mt-auto">
                <div className="row g-2">
                  {[
                    "AI",
                    "IoT",
                    "Robotics",
                    "Drone",
                    "GameDev",
                    "WebApps",
                  ].map((tag, index) => (
                    <div key={index} className="col-4 col-md-auto">
                      <span
                        className="tag-hover border rounded-pill px-3 py-1 small font-red text-dark d-inline-block w-100 text-center"
                        style={{
                          transition: "all 0.3s",
                          cursor: "pointer",
                        }}
                      >
                        {tag}
                      </span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Section */}
      <div className="container my-5">
        <div className="row">
          {/* Blog Cards */}
          <div className="col-lg-8">
            <div className="row">
              {blogData.map((blog, index) => (
                <div className="col-md-6 mb-4" key={index}>
                  <Card className="border-0 overflow-hidden rounded-4 blog-card">
                    <div className="position-relative ratio ratio-16x9 overflow-hidden blog-image-hover-zoom">
                      <Card.Img
                        variant="top"
                        src={blog.image}
                        className="object-fit-cover w-100 h-100 blog-zoom-img"
                      />
                    </div>

                    <Card.Body>
                      {/* Date label */}
                      <div className="position-absolute bg-red top-0 start-0 text-white px-3 py-1 m-3 rounded fw-semibold">
                        {blog.date}
                      </div>
                      <p className="mb-1 mt-2 text-muted">
                        By :
                        <span className="fw-semibold ms-1 fs-6 text-muted">
                          {blog.author}
                        </span>
                        <span className="fw-semibold ms-4 font-red">
                          {blog.category}
                        </span>
                      </p>

                      {/* Title as link */}
                      <h5 className="card-title-blog fw-bold mt-3 text-uppercase">
                        <a
                          id="blog-title-link"
                          className="text-decoration-none"
                          onClick={handleClickBlogSub}
                        >
                          {blog.title}
                        </a>
                      </h5>
                    </Card.Body>
                  </Card>
                </div>
              ))}
            </div>
          </div>

          {/* Sidebar */}
          <div className="col-lg-4 mt-lg-0">
            {/* Recent Posts */}
            <div className="ms-2 shadow" style={{ paddingBottom: "1px" }}>
              <div className="d-flex align-items-center mb-3">
                <div
                  className="me-3 rounded"
                  style={{
                    width: "4px",
                    height: "25px",
                    background: "#41C1EE",
                  }}
                ></div>
                <h5 className="fw-bold font-black mb-0">RECENT POST</h5>
              </div>

              <Row className="gx-4 gy-5 p-3">
                {recentPosts.map((post) => (
                  <Col xs={12} md={6} lg={12} key={post.id}>
                    <div className="d-flex align-items-center">
                      <div className="post-hover d-flex align-items-start">
                        <img
                          src={post.image}
                          alt=""
                          className="me-3 rounded post-image"
                          style={{
                            width: "100px",
                            height: "80px",
                            objectFit: "cover",
                          }}
                        />
                        <div>
                          <p className="text-muted small mb-1">{post.date}</p>
                          <h6
                            className="fw-bold font-black lh-sm mb-0 post-title"
                            style={{ fontSize: "15px" }}
                          >
                            {post.title}
                          </h6>
                        </div>
                      </div>
                    </div>
                  </Col>
                ))}
              </Row>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </HelmetProvider>
  );
};

export default Blog;
